import {defineComponent,h,ref,computed,watch,nextTick,onMounted} from 'vue';
import type {EvidenceSource} from '@knowyet/sdk/evidence';
import type {PreviewRequest} from '@knowyet/preview';
import {EvidencePreview} from '@knowyet/ui-vue/evidence';
import {GraphOriginalPreview} from './graph-original-preview.js';
import {pdfOptions} from './preview-options.js';

/** Location selection only changes the target page, never the underlying evidence. */
export const CitationPreview=defineComponent({
 props:{source:{type:Object as ()=>EvidenceSource,required:true},fallback:{type:Object as ()=>PreviewRequest,required:true},load:{type:Function,required:true}},
 setup(p){
  const page=ref(0),original=ref(false), surface=ref<HTMLElement|null>(null), rendered=ref(false);
  let positioned = false;
  const reveal=()=>{ requestAnimationFrame(()=>requestAnimationFrame(()=>{
    // The overlay can exist before the image has dimensions. Do not consume
    // the one-time scroll until that image has actually loaded and laid out.
    if(target.value&&!original.value){
      const images=[...(surface.value?.querySelectorAll('img')??[])];
      if(!images.length||images.some(image=>!image.complete||!image.naturalWidth)) return;
    }
    const element=surface.value?.querySelector<HTMLElement>('[data-evidence-box],[data-highlighted="true"]');
    if(element&&!positioned){element.scrollIntoView({block:'center',inline:'nearest'});positioned=true;}
  })); };
  watch(()=>[p.source,page.value],()=>{positioned=false;rendered.value=false;});
  onMounted(()=>{void nextTick(reveal);});
  watch(()=>p.source,()=>{page.value=0;original.value=false;void nextTick(reveal);});
  const target=computed(()=>p.source.preview_pages?.[page.value]);
  const request=computed<PreviewRequest>(()=>target.value?{filename:`${p.source.file}-page-${target.value.page}.${target.value.image.media_type === 'image/webp' ? 'webp' : 'png'}`,load:signal=>p.load(target.value!.image,signal)}:p.fallback);
  return()=>target.value&&!original.value?h('section',{'data-testid':'citation-page-preview',ref:surface,onLoadCapture:()=>{rendered.value=true;reveal();}},[
   h('div',{class:'citation-page-toolbar'},[
    h('span',`原件第 ${target.value.page} 页 · 按需预览`),
    ...(p.source.preview_pages!.length>1?[h('select',{'aria-label':'引用页',value:page.value,onChange:(e:Event)=>{page.value=Number((e.target as HTMLSelectElement).value);}},p.source.preview_pages!.map((v,i)=>h('option',{value:i},`第 ${v.page} 页`)))]:[]),
    h('button',{type:'button',onClick:()=>{original.value=true;}},'查看高清原件')]),
   !rendered.value ? h('p',{role:'status'},`正在打开第 ${target.value.page} 页原件…`) : null,
   h(EvidencePreview,{request:request.value,mediaType:target.value.image.media_type,locations:p.source.locations.filter(l=>l.kind==='box'&&l.page===target.value!.page),pdfOptions})
  ]):h('div',{ref:surface,onLoadCapture:reveal},[h(GraphOriginalPreview,{source:p.source as any,request:p.fallback})]);
 }
});
